import { Link } from "react-router-dom";
import ErrorBar from "@/components/errorBar";
import { Button } from "@/components/ui/button";

export default function PageNotFound() {
  return (
    <main className="min-h-screen bg-[var(--surface-ambient)] pt-32">
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-8 px-6 text-center">
        <ErrorBar headerText="Page not found">
          The page you are looking for is unavailable. It may have been moved or deleted.
        </ErrorBar>
        <img
          src="/LUMS23.svg"
          alt="Lancaster University Management School"
          className="h-14 w-auto opacity-80"
        />
        <Link to="/">
          <Button size="sm">Return home</Button>
        </Link>
      </div>
    </main>
  );
}
